import { GenericForm } from "../generic-form/GenericForm.types";
import { GenericFormValidator } from "../generic-form/utility/GenericFormValidator";
import { CreateDigitalSignatureRequestDTO } from "../../entities/IDigitalSignatureRequest";
import { MetaDataForm } from "../../entities/IMetaData";
import { EditViewDigitalSignatureRequestDTO } from "./ViewDigitalSignatureModal.types";

export const requestDigitalSignatureForm: GenericForm<CreateDigitalSignatureRequestDTO> = {
  email: {
    type: "input",
    name: "email",
    label: "DOCUMENTS.CUSTOMER_EMAIL",
    defaultValue: "",
    validators: [GenericFormValidator.required(), GenericFormValidator.email()],
  },
  authorizedSignatory: {
    type: "autocompleteSingleChoice",
    name: "authorizedSignatory",
    label: "DOCUMENTS.AUTHORIZED_SIGNATORY",
    defaultValue: -1,
    validators: [],
  },
  documentId: {
    type: "hidden",
    visibleIf: () => false,
    name: "documentId",
    label: "",
    defaultValue: -1,
    validators: [],
  },
  sendEmailToCustomer: {
    type: "checkbox",
    name: "sendEmailToCustomer",
    label: "DOCUMENTS.SEND_EMAIL_TO_CUSTOMER",
    defaultValue: false,
    validators: [],
  },
};

export interface RequestDigitalSignatureModalProps {
  onDismiss: () => void;
  onSubmit: (data: CreateDigitalSignatureRequestDTO) => void;
  creating: boolean;
  isVisible: boolean;
  requestDigitalSignatureForm: GenericForm<CreateDigitalSignatureRequestDTO>;
}

export interface ViewDigitalSignatureModalProps {
  onDismiss: () => void;
  isVisible: boolean;
  fields: GenericForm<MetaDataForm> | null;
  onDelete: () => void;
  handleEdit: (data: EditViewDigitalSignatureRequestDTO) => void;
  editingSignature: boolean;
}
